module.exports = __webpack_public_path__ + "static/media/loading-image.bb44aefb.gif";